import { nodeTypesGrouped } from '@flowx/designer/modules/bpmn-editor/dictionary/nodes-types'
import { NodeDefinition } from '@flowx/designer/modules/core/dictionary/process.dictionary'
import { SwimlaneSummary } from '@flowx/designer/modules/core/dictionary/swimlane.dictionary'
import { ResourceDocumentationTarget } from '@flowx/designer/shared/components/resource-documentation/resource-documentation.service'
import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'
import { BoundaryEvent } from '@flowx/designer/shared/entities/boundary-event/boundary-event.types'
import { EventNodes, NodeType } from '@flowx/designer/shared/entities/node.types'

const DESCRIPTION_ONLY_NODE_TYPES: NodeType[] = [
  EventNodes.START_EVENT,
  EventNodes.END_EVENT,
  EventNodes.START_TIMER_EVENT,
  EventNodes.INTERMEDIATE_TIMER_EVENT,
]

const NODE_TYPE_TITLES = new Map(
  nodeTypesGrouped
    .flatMap((group) => group.subnodes ?? [])
    .map((subnode) => [subnode.type, subnode.title ?? ''] as const)
)

const sentenceCase = (title: string): string =>
  title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()

export const nodeTypeLabel = (type: NodeType): string =>
  sentenceCase(NODE_TYPE_TITLES.get(type) || 'Node')

export const nodeDocumentationTarget = (
  node: Pick<NodeDefinition, 'flowxUuid' | 'name' | 'type'>,
  processResourceId: string,
  readOnly: boolean
): ResourceDocumentationTarget => ({
  resourceType: ApplicationResourceType.Process,
  resourceId: processResourceId,
  resourceName: node.name ?? '',
  readOnly,
  element: { elementType: 'node', elementId: node.flowxUuid },
  typeLabel: nodeTypeLabel(node.type),
  withDocumentation: !DESCRIPTION_ONLY_NODE_TYPES.includes(node.type),
})

export const boundaryEventDocumentationTarget = (
  boundaryEvent: Pick<BoundaryEvent, 'flowxUuid' | 'name'>,
  processResourceId: string,
  readOnly: boolean
): ResourceDocumentationTarget => ({
  resourceType: ApplicationResourceType.Process,
  resourceId: processResourceId,
  resourceName: boundaryEvent.name ?? '',
  readOnly,
  element: { elementType: 'boundaryEvent', elementId: boundaryEvent.flowxUuid },
  typeLabel: 'Boundary event',
  withDocumentation: false,
})

export const swimlaneDocumentationTarget = (
  swimlane: Pick<SwimlaneSummary, 'flowxUuid' | 'name'>,
  processResourceId: string,
  readOnly: boolean
): ResourceDocumentationTarget => ({
  resourceType: ApplicationResourceType.Process,
  resourceId: processResourceId,
  resourceName: swimlane.name ?? '',
  readOnly,
  element: { elementType: 'swimlane', elementId: swimlane.flowxUuid ?? '' },
  typeLabel: 'Swimlane',
  withDocumentation: true,
})
